import { type CSSProperties, forwardRef, type PropsWithChildren } from 'react';

import styles from './scroll-container.module.scss';

type ScrollContainerProps = {
  width?: string;
  height?: string;
  maxHeight?: string;
  marginRight?: string;
  style?: CSSProperties;
} & PropsWithChildren;

export const ScrollContainer = forwardRef<HTMLDivElement, ScrollContainerProps>(
  ({ width = '100%', height = '100%', marginRight = '2px', maxHeight, style, children }, ref) => {
    return (
      <div
        ref={ref}
        className={styles.root}
        style={{
          width,
          height,
          flex: '1 1 0',
          minHeight: 0,
          marginRight,
          maxHeight,
          ...style,
        }}
      >
        {children}
      </div>
    );
  },
);
